function addProductToList(lid, swat, product) {
  if (!swat || !lid || !product?.epi || !product?.empi || !product?.du) {
    return;
  }

  if (!hasSwatMethod(swat, "addToList")) {
    console.warn("sym missing addToList");
    return;
  }

  try {
    swat.addToList(
      lid,
      product,
      (success) => {
        if (success) {
          window.isProcessingAddToBag = false;
        }
      },
      (err) => {
        console.error("Failed to add product to Swym List:", err);
      },
    );
  } catch (error) {
    console.error("Failed to fetch list:", error);
  }
}

function getProductDetailsAndAddToList(lid, swat, variantId, productUrl, quantity = 1, cprops = {}) {
  if (!swat || !lid || !variantId || !productUrl) {
    return;
  }
  if (!hasSwatMethod(swat, "getProductDetails")) {
    console.warn("sym missing getProductDetails");
    return;
  }
  try {
    swat.getProductDetails(variantId, (productDetails) => {
      if (productDetails) {
        const epi = variantId;
        const empi = productDetails?.id;
        const du = productUrl;
        if (epi && empi && du) {
          addProductToList(lid, swat, { epi, empi, du, qty: quantity, cprops });
        }
      }
    });
  } catch (error) {
    console.error("Failed to get product details", error);
  }
}

function addManyProductsToList(lid, swat, products) {
  if (!swat || !lid) {
    window.processGuestCartInProgress = false;
    return;
  }
  if (!hasSwatMethod(swat, "addProductsToList")) {
    console.warn("sym missing addProductsToList");
    window.processGuestCartInProgress = false;
    return;
  }
  if (!products || !Array.isArray(products) || products.length === 0) {
    window.processGuestCartInProgress = false;
    return;
  }
  try {
    swat.addProductsToList(
      lid,
      products,
      (success) => {
        if (success) {
          // Handle successful addition of products
          window.processGuestCartInProgress = false;
          window.isProcessingAddToBag = false;
        }
      },
      (err) => {
        window.processGuestCartInProgress = false;
        console.error("Failed to add products to Swym List:", err);
      },
    );
  } catch (error) {
    window.processGuestCartInProgress = false;
    console.error("Failed to add products to Swym List:", error);
  }
}

const updateProductFromList = async (lid, swat, product) => {
  if (!swat || !lid) {
    return;
  }

  if (!product || !product.epi || !product.empi || !product.du) {
    return;
  }
  if (!hasSwatMethod(swat, "updateListItem")) {
    console.warn("sym missing updateListItem");
    window.processGuestCartInProgress = false;
    return;
  }
  try {
    swat.updateListItem(
      lid,
      product,
      (success) => {
        if (success) {
          console.log("Product updated successfully");
        }
      },
      (err) => {
        console.error("Failed to update product:", err);
      },
    );
  } catch (error) {
    console.error("Failed to update product:", error);
  }
};

const updateSwymListItem = ({ lid, swat, product }) => {
  return new Promise((resolve, reject) => {
    if (!swat || !lid || !product) {
      return reject(new Error("Missing required fields"));
    }
    if (!hasSwatMethod(swat, "updateListItem")) {
      console.warn("sym missing updateListItem");
      return reject(new Error("swat.updateListItem is missing"));
    }
    try {
      swat.updateListItem(
        lid,
        product,
        (success) => {
          if (success) {
            console.log("Product updated successfully");
            resolve();
          }
        },
        (err) => {
          reject(new Error(err));
        },
      );
    } catch (error) {
      reject(err instanceof Error ? err : new Error(String(err)));
    }
  });
};

const swymCartItemUpdateCallback = async ({ lid, swat, product }) => {
  if (!lid) {
    return console.error("[update list item] missing list data");
  }
  if (!product || !product.epi || !product.empi || !product.du) {
    return console.error("[update list item] missing product data");
  }

  try {
    await updateSwymListItem({ lid, swat, product });
    // If the user updated the value from the cart-drawer refresh
    if (window.location.pathname.includes("products")) {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error on list item update", error);
  }
};

const deleteProductFromList = async (lid, swat, product) => {
  if (!swat || !lid) {
    return;
  }

  if (!product || !product.epi || !product.empi || !product.du) {
    return;
  }

  swat.deleteFromList(
    lid,
    product,
    () => {
      if (!window.deletingPersistentCartQueue) {
        window.deletingPersistentCartQueue = {};
      }
      if (!window.deletingPersistentCartQueue[product.epi]) {
        window.deletingPersistentCartQueue[product.epi] = { isDeleting: false };
      } else {
        window.deletingPersistentCartQueue[product.epi].isDeleting = false;
      }
    },
    (err) => {
      console.error("Failed to delete product:", err);
    },
  );
};

const deleteManyProductFromList = async (lid, swat, products) => {
  if (!swat || !lid) {
    return;
  }

  if (!products || !Array.isArray(products) || products.length === 0) {
    return;
  }

  swat.removeProductsFromList(
    lid,
    products,
    () => {
      products.forEach((product) => {
        if (!window.deletingPersistentCartQueue) {
          window.deletingPersistentCartQueue = {};
        }
        if (!window.deletingPersistentCartQueue[product.epi]) {
          window.deletingPersistentCartQueue[product.epi] = { isDeleting: false };
        } else {
          window.deletingPersistentCartQueue[product.epi].isDeleting = false;
        }
      });
      setCookie("isProcessingCorruptedCart", "false", 1);
    },
    (err) => {
      console.error("Failed to delete products:", err);
    },
  );
};

const fetchListItems = (lastOrderId, lid, swat, callback, processGuestCart) => {
  if (!swat || !lid) {
    return;
  }
  if (!hasSwatMethod(swat, "fetchListCtx")) {
    console.warn("sym missing fetchListCtx");
    return;
  }
  // Define success callback
  let onSuccess = function (listContents) {
    if (callback && typeof callback === "function") {
      callback(listContents, lastOrderId, lid, swat, processGuestCart);
    }
    return listContents;
  };

  // Define error callback
  let onError = function (error) {
    console.error("Error fetching List Contents", error);
  };

  const fetchPayload = {
    lid,
  };

  // Fetch the list content by list id
  try {
    swat.fetchListCtx(fetchPayload, onSuccess, onError);
  } catch (error) {
    console.error("Failed to fetch list: ", error);
  }
};

const processDeletingItem = (product) => {
  const persistentCartId = window.persistent_cart_id;
  const { epi, empi, du } = product || {};
  if (!persistentCartId || !epi || !du) return;

  function onSwymLoadCallback(swat) {
    if (!swat) return;

    window.deletingPersistentCartQueue = {
      ...(window.deletingPersistentCartQueue || {}),
      [epi]: {
        isDeleting: true,
        removeUrl: du,
      },
    };

    try {
      deleteProductFromList(persistentCartId, swat, {
        epi,
        empi,
        du,
      });
    } catch (err) {
      console.error("Failed to fetch product details for removal:", err);
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(onSwymLoadCallback);
};

const renderInjectedMetaInfo = async (productId, productUrl) => {
  if (!productId || !productUrl) return;
  const productPath = productUrl.replace(window.location.origin, "").split("?variant=")[0];
  const productRes = await fetch(`${productPath}?view=custom`);
  const productData = await productRes.json();
  if (!productData) return;

  const conditionContainer = document.getElementById(`fp-injected-condition-${productId}`);
  const shipsWithContainer = document.getElementById(`fp-injected-ships-with-${productId}`);
  if (conditionContainer && productData.condition) {
    conditionContainer.textContent = `Condition: ${productData.condition}`;
    conditionContainer.classList.remove("hidden--important");
  }
  if (shipsWithContainer && productData.ships_with) {
    shipsWithContainer.textContent = `Ships with: ${productData.ships_with}`;
    shipsWithContainer.classList.remove("hidden--important");
  }
};

const renderInjectedSoldOutItems = (soldOutItems) => {
  const container = document.getElementById("fp-injected-sold-out-items");
  const soldOutSection = document.getElementById("fp-sold-out-items-section");
  const soldOutItemsWrapper = document.getElementById("sold-out-items-wrapper");
  if (
    !container ||
    !soldOutSection ||
    !soldOutItemsWrapper ||
    !soldOutItems ||
    !Array.isArray(soldOutItems) ||
    soldOutItems.length === 0
  )
    return;

  const tableRows = soldOutItems.map((item, index) => {
    return `
      <tr
        class="cart-item utility-bar--bottom-border"
        id="CartItem-PersistentSoldOut-${index + 1}"
      >
        <td class="cart-item__media">
          <a
            title="Go to ${item.dt} product details"
            href="${item.du}"
            class="cart-item__link"
            aria-hidden="true"
            tabindex="-1"
          >
          </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img
              src="${item.iu}"
              class="cart-item__image"
              alt="${item.bt} ${item.dt}"
              loading="lazy"
              width="204"
              height="204"
            >
          </div>
        </td>

        <td class="cart-item__details">
          <p class="fp-cart-item__vendor">${item.bt}</p>
          <a
            title="Go to ${item.dt} product details"
            href="${item.du}"
            class="cart-item__name fp-font-weight--regular break"
          >
            ${item.dt}
          </a>
          <div class="fp-cart-item__meta">
            <div
              id="fp-injected-condition-${item.empi}"
              class="fp-cart-item__condition hidden--important"
            ></div>
            <div
              id="fp-injected-ships-with-${item.empi}"
              class="hidden--important"
            ></div>
          </div>
          <div class="fp-cart-item__meta">
            <p class="body-xl fp-cart-item__sold-out-text">Sold Out</p>
          </div>

          <div class="fp-cart-item__footer">
              <a 
              id="fp-cart-find-another"
              href="https://${window.location.hostname}/search?q=${item.dt}"
              title="Search for ${item.dt}"
              >Find Another</a>
          </div>
          
          <cart-remove-button
            id="Remove-${index + 1}"
            data-index="${index + 1}"
          >
            <button
              type="button"
              data-remove-url="remove-from-persistent-cart-only"
              data-variant-id="${item.epi}"
              data-product-id="${item.empi}"
              data-product-url="${item.du}"
              class="button button--tertiary"
              aria-label="Remove ${item.dt} from cart"
              name="Remove ${item.dt} from cart"
            >
              Remove Item
            </button>
          </cart-remove-button>
        </td>
      </tr>
    `;
  });
  container.innerHTML = container.innerHTML + tableRows.join("");

  const numberOfRows = container.querySelectorAll("tr").length;
  soldOutItemsWrapper.innerHTML = numberOfRows > 1 ? `(${numberOfRows} items)` : `(${numberOfRows} item)`;
  soldOutSection.classList.remove("hidden--important");
  soldOutItems.forEach((item) => {
    renderInjectedMetaInfo(item.empi, item.du);
  });
};

const processPersistentCartListSync = async (listContent, lastOrderId, lid, swat, processGuestCart = []) => {
  if (!window.isLoggedIn || !swat || !lid) {
    return;
  }

  const wasPurchasedByUserList = [];
  const wasPurchasedByUserVariantIds = [];

  const appendProductsToList = processGuestCart.flatMap((item) => {
    const giftCardTitle = item.url?.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
    const isGiftCard = giftCardTitle ? giftCardTitle?.includes("giftcard") : false;
    return isGiftCard
      ? []
      : [
          {
            epi: item.variant_id,
            empi: item.product_id,
            du: window.location.origin + item.url,
            qty: item.quantity || 1,
            cprops: item.properties || {},
          },
        ];
  });

  listContent.forEach((item) => {
    const giftCardTitle = item.du?.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
    const isGiftCard = giftCardTitle ? giftCardTitle?.includes("giftcard") : false;
    if (isGiftCard) return;

    const wasPurchasedByUser = item.lOId;
    if (wasPurchasedByUser) {
      wasPurchasedByUserList.push({ epi: item.epi, empi: item.empi, du: item.du });
      wasPurchasedByUserVariantIds.push(item.epi);
    }
  });

  if (!!wasPurchasedByUserList.length) {
    deleteManyProductFromList(lid, swat, wasPurchasedByUserList);
  }

  if (!!appendProductsToList.length) {
    addManyProductsToList(lid, swat, appendProductsToList);
  }

  return;
};

const processSwymCartSync = async (persistentCartId, lastOrderId, processGuestCart) => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  function onSwymLoginCallback(swat) {
    if (!swat) {
      return;
    }
    fetchListItems(lastOrderId, persistentCartId, swat, processPersistentCartListSync, processGuestCart);
  }
  window.SwymCallbacks.push(onSwymLoginCallback);
};

const processLoginCart = async (persistentCartId, cartItems) => {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  function onSwymLoginCallback(swat) {
    if (!swat) return;
    // To Temporarily disable adding items to cart from Swym Persistent Cart comment 2 below lines;
    fetchListItems(cartItems, persistentCartId, swat, processPersistentCart, "instock");
    fetchListItems(cartItems, persistentCartId, swat, processSoldOutItems, "outofstock");

    // TO DO: Persist sold out items
    // document.body.addEventListener("click", async (e) => {
    //   const target = e.target.closest("button[data-remove-url], button[data-variant-id].link");
    //   if (!target) return;
    //   const variantId = Number(target.getAttribute("data-variant-id"));
    //   const productId = Number(target.getAttribute("data-product-id"));
    //   const productUrl = target.getAttribute("data-product-url");
    //   const removeUrl = target.getAttribute("data-remove-url");
    //   const tableRow = target.closest("tr");
    //   const container = document.getElementById("fp-injected-sold-out-items");
    //   const soldOutSection = document.getElementById("fp-sold-out-items-section");
    //   const soldOutItemsWrapper = document.getElementById("sold-out-items-wrapper");

    //   if (!variantId || !productId) {
    //     return;
    //   }

    //   if (removeUrl === "remove-from-persistent-cart-only" && tableRow && variantId && productId && productUrl) {
    //     tableRow.remove();
    //     processDeletingItem({
    //       epi: variantId,
    //       empi: productId,
    //       du: productUrl,
    //     });
    //     // Update count
    //     if (!container || !soldOutSection || !soldOutItemsWrapper) return;
    //     const numberOfRows = container.querySelectorAll("tr").length;
    //     if (numberOfRows < 1) {
    //       soldOutSection.classList.add("hidden");
    //     } else {
    //       soldOutItemsWrapper.innerHTML = numberOfRows > 1 ? `(${numberOfRows} items)` : `(${numberOfRows} item)`;
    //     }
    //   }
    // });
  }
  window.SwymCallbacks.push(onSwymLoginCallback);
};

function onSwymLoadCallback(swat) {
  if (!swat) return;

  function getSocialCountAsync(product) {
    return new Promise((resolve, reject) => {
      swat.wishlist.getSocialCount(product, resolve, reject);
    });
  }

  async function handleSocialCounts(item) {
    try {
      const data = await getSocialCountAsync({
        empi: item.getAttribute("data-product-id"),
      });

      const count = data?.data?.count ?? null;
      if (typeof count === "number" && count >= 0) {
        document
          .querySelectorAll(`.fp-collections-social-count[data-product-id="${data.data.empi}"]`)
          .forEach((divElem) => {
            if (!divElem) return;
            if (count === 0) {
              divElem.style.display = "none";
            } else {
              divElem.style.display = "";
              divElem.innerHTML = count <= 999 ? count : "999+";
            }
          });
      }
    } catch (error) {
      console.error("Error while fetching social count:", error);
    }
  }

  async function fetchAndUpdateSocialCount(evt) {
    swat.initializeActionButtons("body");
    const specificProductId = evt?.detail?.d?.empi;
    const swymSocialCounts = document.querySelectorAll(
      !specificProductId
        ? ".fp-collections-social-count"
        : `.fp-collections-social-count[data-product-id="${specificProductId}"]`,
    );
    try {
      await runParallel({ arr: Array.from(swymSocialCounts), fn: handleSocialCounts, batch: 40 });
    } catch (error) {
      console.error(error);
    } finally {
      setAllWishlistBtnAriaLabelAttrs();
    }
  }

  function setAllWishlistBtnAriaLabelAttrs() {
    const buttons = document.querySelectorAll(".swym-add-to-wishlist-view-product");
    if (!buttons) return;
    buttons.forEach((btn) => {
      const countEl = btn.querySelector(".fp-collections-social-count");
      const count = countEl?.textContent?.trim();
      const label = count
        ? `${count} - Add ${btn.getAttribute("data-product-name")} To Wishlist`
        : `Add ${btn.getAttribute("data-product-name")} To Wishlist`;
      btn.setAttribute("aria-label", label);
    });
  }

  // NOTE: Debounced function to prevent multiple rapid calls (N+1 queries) when users perform bulk actions.
  let debounceFetchAndUpdateSocialCount = debounce(fetchAndUpdateSocialCount, 250);

  // Add listener for the 'addedtowishlist' event to the Swym Event Layer
  swat.evtLayer.addEventListener("sw:addedtowishlist", (e) => {
    if (window.isProcessingAddToBag) {
      return;
    }
    debounceFetchAndUpdateSocialCount(e);
  });

  // Add listener for the 'removedfromwishlist' event to the Swym Event Layer
  swat.evtLayer.addEventListener("sw:removedfromwishlist", debounceFetchAndUpdateSocialCount);

  // Add custom event
  document.addEventListener("swym:update-social-count", debounceFetchAndUpdateSocialCount);

  // initialize
  swat.initializeActionButtons("body");
  // NOTE: Since SWYM injects default aria-label attributes during initialization, we need to update them afterward with our own custom text.

  setTimeout(() => {
    setAllWishlistBtnAriaLabelAttrs();
  }, 0); //NOTE: execute at the end of the call stack
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

function insertSwymEnhancements() {
  const swymContainerShared = document.querySelector(".swym-readonly-text");
  const swymContainerSelf = document.querySelector(".swym-wishlist-container-title-bar");
  const headingInserted = !!document.querySelector("#following-list-heading");

  // Handle heading injection
  if (swymContainerShared && !headingInserted) {
    const span = swymContainerShared.querySelector("span");
    if (span && span.textContent.includes("shared by")) {
      const originalText = span.textContent;

      const nameOnly = originalText
        .replace("You are viewing a read-only list shared by ", "")
        .replace(/\(.*?\)/, "")
        .replace(/\.$/, "")
        .trim();

      const firstName = nameOnly.split(".")[0];
      const possessive = firstName.endsWith("s") ? `${firstName}'` : `${firstName}'s`;

      const heading = document.createElement("h1");
      heading.textContent = `${possessive} Following List`;
      heading.id = "following-list-heading";
      swymContainerShared.appendChild(heading);
    }
  } else if (swymContainerSelf && !headingInserted) {
    const possessive = "My Shared";
    const heading = document.createElement("h1");
    heading.textContent = `${possessive} Following List`;
    heading.id = "following-list-heading";
    swymContainerSelf.appendChild(heading);
  }

  async function handleAddToCartClick(event) {
    const searchTerm = event.target.dataset.searchTerm || "";
    const isSoldOut = event.target.dataset.isSoldOut === "true";
    if (isSoldOut) {
      window.location.replace(searchTerm || "https://" + window.location.host + "/search?q=");
      return;
    } else {
      event.target.dataset.isInCart = "true";
      event.target.disabled = true;
      event.target.textContent = "Added To Bag";
      event.target["aria-label"] = "Added To Bag";
      event.target.classList.add("swym-disabled-btn");
      setTimeout(async () => {
        const itemCount = document.querySelector("#CartDrawer-ItemCount");
        const cartItems = await getCartItems();
        const lastItem = cartItems?.[0] || null;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") {
          if (typeof cartDrawer.renderContents === "function") {
            if (lastItem) {
              cartDrawer.renderContents(lastItem);
              if (itemCount) {
                itemCount.textContent = `${cartItems.length} items`;
              }
            }
          }
          const sectionsRes = await fetch(`/cart?sections=cart-drawer,cart-icon-bubble,cart-drawer-items`);
          const parsedState = await sectionsRes.json();
          window.dispatchEvent(new Event("refresh-cart-drawer"));
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "quick-add",
            cartData: parsedState,
          });
        } else if (cartDrawer) {
          cartDrawer.classList.add("active");
          cartDrawer.style.visibility = "visible";
        }
        return;
      }, 1000);
    }
  }

  document.querySelectorAll(".swym-wishlist-item").forEach((item) => {
    const vendorTitle = item.querySelector(".swym-vendor-title");
    const titleExists = !!item.querySelector(".swym-title-link");
    const productTitle = item.querySelector(".swym-title")?.textContent.trim() || "";
    const imageWrapper = item.querySelector(".swym-wishlist-image-wrapper");
    const variantHref = imageWrapper ? imageWrapper.getAttribute("href") : "#";
    const variantHrefSplit = variantHref ? variantHref.split("?variant=") : [];
    const productHref = variantHrefSplit ? variantHrefSplit[0] : "#";
    const variantId = variantHrefSplit.length > 1 ? variantHrefSplit.pop() : null;
    const cartItems = Array.isArray(window.cartItems) ? window.cartItems : [];
    const isInCart = cartItems.includes(variantId);
    const searchTerm = "https://" + window.location.host + "/search?q=" + encodeURIComponent(productTitle);
    const soldOutIconLink = document.createElement("a");
    soldOutIconLink.href = searchTerm;

    const soldOutIconDiv = document.createElement("div");
    soldOutIconDiv.className = "fp-soldout-icon";
    soldOutIconDiv.setAttribute("role", "button");
    soldOutIconDiv.setAttribute("tabindex", "0");

    const soldOutIconImg = document.createElement("img");
    soldOutIconImg.src =
      "https://cdn.shopify.com/s/files/1/0894/3186/7695/files/content-sold-out-icon.png?v=1760066184";
    soldOutIconImg.alt = "Sold Out: Find Another";

    soldOutIconDiv.appendChild(soldOutIconImg);
    soldOutIconLink.appendChild(soldOutIconDiv);

    const buttons = item.querySelectorAll(".swym-add-to-cart-btn");
    if (imageWrapper) {
      imageWrapper.addEventListener("click", () => {
        sessionStorage.setItem("referrerURL", window.location.href);
      });
    }

    const findAnotherButton = item.querySelector(".swym-add-to-cart-btn");
    if (findAnotherButton && findAnotherButton.textContent.trim() === "Find Another") {
      findAnotherButton.addEventListener("click", () => {
        sessionStorage.setItem("referrerURL", window.location.href);
      });
      if (imageWrapper && !item.querySelector(".fp-soldout-icon")) {
        imageWrapper.insertAdjacentElement("afterend", soldOutIconLink);
      }
      const productPrice = item.querySelector(".swym-product-price");
      if (productPrice) {
        productPrice.remove();
      }
    }

    buttons.forEach((button) => {
      if (!button.dataset.listenerAdded) {
        button.addEventListener("click", handleAddToCartClick);
        button.dataset.searchTerm = "https://" + window.location.host + "/search?q=" + encodeURIComponent(productTitle);
        button.dataset.isInCart = isInCart ? "true" : "false";
        button.dataset.variantId = variantId;
        button.dataset.productUrl = productHref;
        button.dataset.listenerAdded = "true"; // Mark as bound
        button.classList.add("button");
      }
      if (button) {
        button.style.display = "none";
      }
    });

    if (vendorTitle && productTitle && !titleExists) {
      const link = document.createElement("a");
      link.href = productHref + (productHref.includes("?") ? "&" : "?") + "from=following";
      link.className = "swym-title-link";

      const nameElement = document.createElement("p");
      nameElement.innerText = productTitle;
      link.appendChild(nameElement);

      vendorTitle.insertAdjacentElement("afterend", link);
    }
  });

  // Force button labels to "Add To Bag"
  document.querySelectorAll(".swym-add-to-cart-btn").forEach((button) => {
    const text = button.textContent.trim();
    const disabledStatus = button.disabled;
    const isInCart = button.dataset.isInCart === "true";
    const isSoldOut = disabledStatus && !isInCart;
    if (isSoldOut) {
      button.dataset.isSoldOut = isSoldOut;
    }
    if (text !== "Add To Bag" && text !== "Added To Bag" && text !== "Find Another") {
      button.textContent =
        isSoldOut || button.dataset.isSoldOut ? "Find Another" : isInCart ? "Added To Bag" : "Add To Bag";
      button["aria-label"] =
        isSoldOut || button.dataset.isSoldOut ? "Find Another" : isInCart ? "Added To Bag" : "Add To Bag";
      button.disabled = isInCart ? true : false;
    }
  });
}

// NOTE: ensure shoppers are logged in before they can add products to wishlist
function swymEnsureLoggedInCB(swat) {
  if (window.isLoggedIn == false) {
    SwymUtils.getHostedURL = function () {
      return "/account/login";
    };
    swat.ui.open = function () {
      console.warn("No user logged in! Swym redirecting to account login.");
      swymRedirectToLogin();
    };
    swat.api.addToWishList = function () {
      console.warn("No user logged in! Swym redirecting to account login.");
      swymRedirectToLogin();
    };

    swat.ui.uiRef.addToWishlist = function () {
      console.warn("No user logged in! Swym redirecting to account login.");
      swymRedirectToLogin();
    };
  }
  function swymRedirectToLogin() {
    const accountsPageURL = getLoginUrl();
    window.location = accountsPageURL;
  }
}

window.SwymCallbacks.push(swymEnsureLoggedInCB);

// Run initially
insertSwymEnhancements();

// Setup a single MutationObserver for all DOM changes
const swymObserver = new MutationObserver(() => {
  insertSwymEnhancements();
});

swymObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

function processAddingItem(product) {
  const { epi, empi, du, qty, cprops } = product || {};
  const persistentCartId = window.persistent_cart_id;
  const giftCardTitle = du?.toLowerCase().replaceAll(" ", "").replaceAll("-", "");
  const isGiftCard = giftCardTitle ? giftCardTitle?.includes("giftcard") : false;
  // TODO: Skip adding gift cards to persistent cart for now
  if (isGiftCard || !persistentCartId || !epi || !du) return;

  function onSwymLoadCallback(swat) {
    if (!swat) return;
    // Set flag to prevent social count update triggered by cart add
    window.isProcessingAddToBag = true;
    if (qty > 1) {
      updateProductFromList(persistentCartId, swat, product);
    } else if (empi) {
      addProductToList(persistentCartId, swat, product);
    } else {
      getProductDetailsAndAddToList(persistentCartId, swat, epi, du, qty, cprops);
    }
  }
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
}

function hasSwatMethod(swat, methodName) {
  return typeof swat?.[methodName] === "function";
}
